/* eslint-disable no-undef */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['clickToSignContainer', 'signatureContainer', 'checkbox']

  toggle() {
    this.clickToSignContainerTarget.classList.toggle('d-none')
    this.signatureContainerTarget.classList.toggle('d-none')
    this.checkboxTarget.checked = !this.checkboxTarget.checked

    document.dispatchEvent(new Event('signature:toggle'))
  }

  toggleAll(){
    let signatureContainers = document.querySelectorAll('[data-signing--click-to-sign-target="clickToSignContainer"]')
    signatureContainers.forEach(container => {
      let checkbox = container.parentElement.querySelector('[data-signing--click-to-sign-target="checkbox"]')
      !checkbox.checked && container.click()
    })
  }
}
